import type { RouteRecordRaw } from "vue-router"

import { isAnonymous } from "@/routers/router-guardians"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/modules/auth/pages/Login.vue"),
    beforeEnter(to, from, next) {
      isAnonymous(to, from, next)
    }
  }
]

export default routes
